import React, { useEffect, useState } from "react";
import { selectCurrent } from '../redux/theme/selectors'
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { user } from "../redux/user/actions";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { addressBooks } from "../redux/address-books/action";
import storePersist from "../redux/storePersist";
import useWindowDimensions from "../hooks/useWindowsDimensions";
import * as R from 'ramda';
import GoogleMapSearch from "../common/components/google-map-search";
import _ from "lodash";

export default function EditProfileAddress({ addressBookId, address }: any) {
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const [steps, setSteps] = useState<any>({})
	const { height, width } = useWindowDimensions();

	const statesItems = storePersist?.get("states")?.current?.items;
	const countriesItems = storePersist?.get("countries")?.current?.items;

	const [locations, setLocations] = useState<any>({
		name: '',
		lat: '',
		lng: '',
		pincode: '',
		description: '',
	});

	interface ISteps {
		CategoryName: string;
		ItemName: string
		PackageType: string
		Weight: string
		Width: string
		Height: string
		Length: string
		AdditionalInfo: string
		NumberOfItems: number
	}

	const dispatch = useAppDispatch();
	const handleClose = () => {
		dispatch(user.set({ editProfile: 'close' }))
	}

	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}
	useEffect(() => {
		if (locations?.description || locations?.lat) {
			const addressData = _.split(locations?.description, ',');
			let stateName = addressData[4]?.replace(/\d+/g, '').trim().toLowerCase();
			let stateData = _.find(statesItems, item => item.Name.toLowerCase() === stateName);
			setSteps(prev => ({
				...prev,

				Address1: `${addressData[0]}`,
				Address2: `${addressData[1]},${addressData[2]}`,
				City: `${addressData[3]}`,
				PinCode: locations?.pincode,
				StateProvinceId: stateData?.Id,
				Latitude: locations?.lat,
				Longitude: locations?.lng,
				CountryId: 133

			}));

		} else if (!locations?.description) {
			setSteps(prev => ({
				...prev,
				Address1: address?.Address1,
				Address2: address?.Address2,
				City: address?.City,
				PinCode: address?.ZipPostalCode,
				StateProvinceId: address?.StateProvinceId,
				CountryId: 133,
				Latitude: address?.Latitude,
				Longitude: address?.Longitude,
				emailAddress: address?.Email,
				FirstName: address?.FirstName,
				LastName: address?.LastName,
				Phone: address?.PhoneNumber
			}));
		}

	}, [locations]);

	const handleSave = async (event: any) => {
		event.preventDefault();
		await dispatch(addressBooks.update({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-features/addressbooks/update-address`, entity: 'brands', jsonData: {

				"Records": [
					{
						Id: addressBookId,
						Address: {
							Id: address.Id,
							FirstName: steps?.firstName,
							LastName: steps?.lastName,
							Email: steps?.emailAddress,
							PhoneNumber: steps?.Phone,
							Address1: steps?.Address1,
							Address2: steps?.Address2,
							City: steps?.City,
							Latitude: steps?.Latitude,
							Longitude: steps?.Longitude,
							ZipPostalCode: steps?.PinCode,
							StateProvinceId: steps?.StateProvinceId,
							CountryId: steps?.CountryId,
						}
					}
				]

			}
		}))

		await handleClose()


	}


	return (
		<>
			{width && width < 720 ?
				//  Start - Mobile View 
				<>
					{address && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
						<div className="w-full max-w-3xl mt-3 mx-4 bg-primary text-white rounded-xl shadow-lg">
							<div className="flex items-start justify-between w-full border-b p-2 border-blue-500">
								<div className="flex w-full flex-col items-start justify-between text-xl p-2">
									Edit Address
								</div>
								<div className="cursor-pointer p-2">
									<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x-circle">
										<circle cx="12" cy="12" r="10" />
										<path d="m15 9-6 6" />
										<path d="m9 9 6 6" />
									</svg>
								</div>
							</div>

							<form onSubmit={handleSave} className="space-y-6 scrollbar-hide overflow-y-auto max-h-[60vh] p-6">
								<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
									{/* First Name */}
									<div>
										<label className="block text-sm font-normal mb-1">First Name</label>
										<input
											disabled
											{...register('firstName', { required: true, maxLength: 15 })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="First Name"
											value={address.FirstName || steps.FirstName}
											onChange={(e) => handleSteps(e, 'firstName')}
										/>
										{errors.firstName && (
											<p className="text-red-500 text-xs mt-1">{errors.firstName.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* Last Name */}
									<div>
										<label className="block text-sm font-normal  mb-1">Last Name</label>
										<input
											disabled
											{...register('lastName', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Last Name"
											value={steps.LastName}
											onChange={(e) => handleSteps(e, 'lastName')}
										/>
										{errors.lastName && (
											<p className="text-red-500 text-xs mt-1">{errors.lastName.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* Email Address */}
									<div className="md:col-span-2">
										<label className="block text-sm font-normal  mb-1">Email Address</label>
										<input
											type="email"
											{...register('emailAddress', {
												required: true,
												pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
											})}
											className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Email Address"
											value={steps.emailAddress}
											onChange={(e) => handleSteps(e, 'emailAddress')}
										/>
										{errors.emailAddress && (
											<p className="text-red-500 text-xs mt-1">
												{errors.emailAddress.type === "required" ? "This is required" : "Please enter a valid email"}
											</p>
										)}
									</div>

									{/* Phone */}
									<div className="md:col-span-2">
										<label className="block text-sm font-normal  mb-1">Phone</label>
										<input
											type="number"
											min={10}
											{...register('Phone', {
												required: true,
												maxLength: 10,
												minLength: 10,
												pattern: /^[0-9+-]+$/
											})}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Phone"
											value={steps.Phone}
											onChange={(e) => handleSteps(e, 'Phone')}
										/>
										{errors.Phone && (
											<p className="text-red-500 text-xs mt-1">Please enter a valid mobile number</p>
										)}
									</div>
									{/* Address Search */}
									<div className="md:col-span-2">
										<label className="block text-sm font-normal  mb-1">Address Search</label>
										<GoogleMapSearch
											className="appearance-none Block w-full font-normal  text-black rounded shadow focus:outline-none focus:ring ps-8  pe-10 py-2"
											setLocation={setLocations}
											location={locations}
											placeholder="Search your address"
											required
										/>
									</div>
									{/* Address1 */}
									<div>
										<label className="block text-sm font-normal mb-1">Building</label>
										<textarea
											{...register('Address1', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Building"
											disabled={!locations?.description}
											value={steps?.Address1}
											onChange={(e) => handleSteps(e, 'Address1')}
										/>
										{errors.Address1 && (
											<p className="text-red-500 text-xs mt-1">{errors.Address1.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* Address2 */}
									<div>
										<label className="block text-sm font-normal  mb-1">Locality</label>
										<textarea
											{...register('Address2', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Locality"
											disabled={!locations?.description}
											value={steps?.Address2}
											onChange={(e) => handleSteps(e, 'Address2')}
										/>
										{errors.Address2 && (
											<p className="text-red-500 text-xs mt-1">{errors.Address2.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* City */}
									<div>
										<label className="block text-sm font-normal  mb-1">City</label>
										<input
											{...register('City', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="City"
											disabled={!locations?.description}
											value={steps?.City}
											onChange={(e) => handleSteps(e, 'City')}
										/>
										{errors.City && (
											<p className="text-red-500 text-xs mt-1">{errors.City.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* PinCode */}
									<div>
										<label className="block text-sm font-normal  mb-1">PinCode</label>
										<input
											{...register('PinCode', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="PinCode"
											disabled={!locations?.description}
											value={steps?.PinCode}
											onChange={(e) => handleSteps(e, 'PinCode')}
										/>
										{errors.PinCode && (
											<p className="text-red-500 text-xs mt-1">{errors.PinCode.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* Country */}
									<div>
										<label className="block text-sm font-normal mb-1">Country</label>
										<select
											disabled
											{...register('CountryId', { required: true })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											id="default"
											onChange={(e) => handleSteps(e, 'CountryId')}
											value={133}
										>

											<option>--Select--</option>
											{countriesItems?.map((item: any, index: any) => (
												<option value={item.Id} key={index}>{item.Name}</option>
											)
											)}

										</select>
										{errors.CountryId && (
											<p className="text-red-500 text-xs mt-1">{errors.CountryId.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>
									{/* Sate */}
									<div>
										<label className="block text-sm font-normal mb-1">State</label>
										<select
											{...register('StateProvinceId', { required: true })}
											className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
											id="default"
											disabled={!locations?.description}
											onChange={(e) => handleSteps(e, 'StateProvinceId')}
											value={steps?.StateProvinceId}
										>

											<option>--Select--</option>
											{statesItems?.map((item: any, index: any) => (
												<option value={item.Id} key={index}>{item.Name}</option>
											)
											)}

										</select>
										{errors.StateProvinceId && (
											<p className="text-red-500 text-xs mt-1">{errors.StateProvinceId.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>
								</div>

								<div className="pt-4">
									<button
										type="submit"
										className="w-full bg-hilight text-black text-lg font-semibold py-2 rounded shadow hover:bg-yellow-300 transition"
									>
										Save Address
									</button>
								</div>
							</form>
						</div>
					</div>}
				</>
				//  End - Mobile View  
				:
				//  Start - Web View 
				<>
					{address && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
						<div className="w-full max-w-3xl mt-3 bg-primary text-white rounded-xl shadow-lg">
							<div className="flex justify-between items-center border-b border-blue-500 px-6 py-4">
								<h2 className="text-2xl font-semibold">Edit Address</h2>
								<button onClick={handleClose} className="text-white hover:text-gray-300">
									<svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<circle cx="12" cy="12" r="10" />
										<path d="M15 9L9 15M9 9l6 6" />
									</svg>
								</button>
							</div>

							<form onSubmit={handleSave} className="space-y-6 overflow-y-auto max-h-[60vh] p-6">
								<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
									{/* First Name */}
									<div>
										<label className="block text-sm font-normal mb-1">First Name</label>
										<input
											disabled
											{...register('firstName', { required: true, maxLength: 15 })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="First Name"
											value={address.FirstName || steps.FirstName}
											onChange={(e) => handleSteps(e, 'firstName')}
										/>
										{errors.firstName && (
											<p className="text-red-500 text-xs mt-1">{errors.firstName.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* Last Name */}
									<div>
										<label className="block text-sm font-normal  mb-1">Last Name</label>
										<input
											disabled
											{...register('lastName', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Last Name"
											value={steps.LastName}
											onChange={(e) => handleSteps(e, 'lastName')}
										/>
										{errors.lastName && (
											<p className="text-red-500 text-xs mt-1">{errors.lastName.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* Email Address */}
									<div className="md:col-span-2">
										<label className="block text-sm font-normal  mb-1">Email Address</label>
										<input
											type="email"
											{...register('emailAddress', {
												required: true,
												pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
											})}
											className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Email Address"
											value={steps.emailAddress}
											onChange={(e) => handleSteps(e, 'emailAddress')}
										/>
										{errors.emailAddress && (
											<p className="text-red-500 text-xs mt-1">
												{errors.emailAddress.type === "required" ? "This is required" : "Please enter a valid email"}
											</p>
										)}
									</div>

									{/* Phone */}
									<div className="md:col-span-2">
										<label className="block text-sm font-normal  mb-1">Phone</label>
										<input
											type="number"
											min={10}
											{...register('Phone', {
												required: true,
												maxLength: 10,
												minLength: 10,
												pattern: /^[0-9+-]+$/
											})}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Phone"
											value={steps.Phone}
											onChange={(e) => handleSteps(e, 'Phone')}
										/>
										{errors.Phone && (
											<p className="text-red-500 text-xs mt-1">Please enter a valid mobile number</p>
										)}
									</div>
									{/* Address Search */}
									<div className="md:col-span-2">
										<label className="block text-sm font-normal  mb-1">Address Search</label>
										<GoogleMapSearch
											className="appearance-none Block w-full font-normal  text-black rounded shadow focus:outline-none focus:ring ps-8  pe-10 py-2"
											setLocation={setLocations}
											location={locations}
											placeholder="Search your address"
											required
										/>
									</div>
									{/* Address1 */}
									<div>
										<label className="block text-sm font-normal mb-1">Building</label>
										<textarea
											{...register('Address1', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Building"
											disabled={!locations?.description}
											value={steps?.Address1}
											onChange={(e) => handleSteps(e, 'Address1')}
										/>
										{errors.Address1 && (
											<p className="text-red-500 text-xs mt-1">{errors.Address1.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* Address2 */}
									<div>
										<label className="block text-sm font-normal  mb-1">Locality</label>
										<textarea
											{...register('Address2', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="Locality"
											disabled={!locations?.description}
											value={steps?.Address2}
											onChange={(e) => handleSteps(e, 'Address2')}
										/>
										{errors.Address2 && (
											<p className="text-red-500 text-xs mt-1">{errors.Address2.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* City */}
									<div>
										<label className="block text-sm font-normal  mb-1">City</label>
										<input
											{...register('City', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="City"
											disabled={!locations?.description}
											value={steps?.City}
											onChange={(e) => handleSteps(e, 'City')}
										/>
										{errors.City && (
											<p className="text-red-500 text-xs mt-1">{errors.City.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* PinCode */}
									<div>
										<label className="block text-sm font-normal  mb-1">PinCode</label>
										<input
											{...register('PinCode', { required: true, maxLength: 30 })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											placeholder="PinCode"
											disabled={!locations?.description}
											value={steps?.PinCode}
											onChange={(e) => handleSteps(e, 'PinCode')}
										/>
										{errors.PinCode && (
											<p className="text-red-500 text-xs mt-1">{errors.PinCode.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>

									{/* Country */}
									<div>
										<label className="block text-sm font-normal mb-1">Country</label>
										<select
											disabled
											{...register('CountryId', { required: true })}
											className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
											id="default"
											onChange={(e) => handleSteps(e, 'CountryId')}
											value={133}
										>

											<option>--Select--</option>
											{countriesItems?.map((item: any, index: any) => (
												<option value={item.Id} key={index}>{item.Name}</option>
											)
											)}

										</select>
										{errors.CountryId && (
											<p className="text-red-500 text-xs mt-1">{errors.CountryId.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>
									{/* Sate */}
									<div>
										<label className="block text-sm font-normal mb-1">State</label>
										<select
											{...register('StateProvinceId', { required: true })}
											className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
											id="default"
											disabled={!locations?.description}
											onChange={(e) => handleSteps(e, 'StateProvinceId')}
											value={steps?.StateProvinceId}
										>

											<option>--Select--</option>
											{statesItems?.map((item: any, index: any) => (
												<option value={item.Id} key={index}>{item.Name}</option>
											)
											)}

										</select>
										{errors.StateProvinceId && (
											<p className="text-red-500 text-xs mt-1">{errors.StateProvinceId.type === "required" ? "This is required" : "Max length exceeded"}</p>
										)}
									</div>
								</div>

								<div className="pt-4">
									<button
										type="submit"
										className="w-full bg-hilight text-black text-lg font-semibold py-2 rounded shadow hover:bg-yellow-300 transition"
									>
										Save Address
									</button>
								</div>
							</form>
						</div>
					</div>}
				</>
				//  End - Web View 
			}
		</>
	);
}